import React from "react";

export const ChangeFormIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    {...props} // Spread any additional props
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.32698 7.63803C3 8.27976 3 9.11984 3 10.8V11.7C3 13.3802 3 14.2202 3.32698 14.862C3.6146 15.4265 4.07354 15.8854 4.63803 16.173C5.27976 16.5 6.11984 16.5 7.8 16.5H28.2C29.8802 16.5 30.7202 16.5 31.362 16.173C31.9265 15.8854 32.3854 15.4265 32.673 14.862C33 14.2202 33 13.3802 33 11.7V10.8C33 9.11984 33 8.27976 32.673 7.63803C32.3854 7.07354 31.9265 6.6146 31.362 6.32698C30.7202 6 29.8802 6 28.2 6H7.8C6.11984 6 5.27976 6 4.63803 6.32698C4.07354 6.6146 3.6146 7.07354 3.32698 7.63803ZM9.75 9.75H6.75V12.75H9.75V9.75Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.32698 21.138C3 21.7798 3 22.6198 3 24.3V25.2C3 26.8802 3 27.7202 3.32698 28.362C3.6146 28.9265 4.07354 29.3854 4.63803 29.673C5.27976 30 6.11984 30 7.8 30H28.2C29.8802 30 30.7202 30 31.362 29.673C31.9265 29.3854 32.3854 28.9265 32.673 28.362C33 27.7202 33 26.8802 33 25.2V24.3C33 22.6198 33 21.7798 32.673 21.138C32.3854 20.5735 31.9265 20.1146 31.362 19.827C30.7202 19.5 29.8802 19.5 28.2 19.5H7.8C6.11984 19.5 5.27976 19.5 4.63803 19.827C4.07354 20.1146 3.6146 20.5735 3.32698 21.138ZM9.75 23.25H6.75V26.25H9.75V23.25Z"
    />
  </svg>
);
